import React, { useEffect, useRef } from 'react';

const BLOCK_COLOR = '#EEF0F3';

const containerStyle = {
  boxSizing: 'border-box',
  display: 'flex',
  flexDirection: 'column',
  gap: '16px',
  padding: '28px',
  background: '#FFFFFF',
  border: '1px solid #E5E7EB',
  borderRadius: '16px'
};

const gridStyle = {
  display: 'grid',
  gridTemplateColumns: '1fr 1fr',
  gap: '10px'
};

const visuallyHiddenStyle = {
  position: 'absolute',
  width: '1px',
  height: '1px',
  overflow: 'hidden',
  clip: 'rect(0 0 0 0)',
  whiteSpace: 'nowrap'
};

function Block({ width = '100%', height, radius = '8px' }) {
  return <div style={{ width, height, borderRadius: radius, background: BLOCK_COLOR }} />;
}

export function LoadingSkeleton() {
  const ref = useRef(null);

  useEffect(() => {
    const element = ref.current;
    const reduceMotion = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;
    if (!element?.animate || reduceMotion) return undefined;

    const animation = element.animate(
      [{ opacity: 1 }, { opacity: 0.55 }, { opacity: 1 }],
      { duration: 1400, iterations: Infinity, easing: 'ease-in-out' }
    );
    return () => animation.cancel();
  }, []);

  return (
    <div role="status" aria-busy="true" style={containerStyle}>
      <span style={visuallyHiddenStyle}>Carregando formulário de doação</span>
      <div ref={ref} aria-hidden="true" style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
        <Block width="55%" height="24px" />
        <Block width="80%" height="14px" />
        <Block height="48px" radius="10px" />
        <div style={{ display: 'flex', gap: '8px' }}>
          <Block width="76px" height="32px" radius="999px" />
          <Block width="66px" height="32px" radius="999px" />
        </div>
        <div style={gridStyle}>
          <Block height="52px" radius="10px" />
          <Block height="52px" radius="10px" />
          <Block height="52px" radius="10px" />
          <Block height="52px" radius="10px" />
        </div>
        <Block height="52px" radius="10px" />
        <Block height="44px" radius="10px" />
        <Block height="52px" radius="10px" />
      </div>
    </div>
  );
}
